import React, {useState} from 'react';
import TextBox from '../components/textbox'
import ButtonComp from '../components/button'
import '../styling/containerStyles.css'
import Label from '../components/label'
import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';
import $ from 'jquery';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Chip from '@material-ui/core/Chip';
import PreviousBankDetails from '../container/previousBankDetails';
interface BankDetailsProps{
    handleToUpdatePayment:Function;
    bankMsg:string;

    handleToProceed:Function;
    previouslyAddedBankTransaction:Function;
    removePreiouslyAddedBanks:Function;
    previousBankDetails: any,
    amount: any;
    prevBankType: any;
}

const BanksList = [
    { title: 'Allahabad Bank' },
    { title: 'Andhra Bank' },
    { title: 'Axis Bank' },
    { title: 'Bank of Baroda' },
    { title: 'Bank of India' },
    { title: 'Bank of Maharashtra' },
    { title: 'Canara Bank' },
    { title: 'Central Bank of India' },
    { title: 'City Union Bank' },
    { title: 'Deutsche Bank' },
    { title: 'Development Credit Bank' },
    { title: 'HDFC Bank' },
    { title: 'Federal Bank' },
    { title: 'ICICI Bank' },
    { title: 'IDBI Bank' },
    { title: 'Indian Bank' },
    { title: 'Indian Overseas Bank' },
    { title: 'IndusInd Bank' },
    { title: 'ING Vysya Bank' },
    { title: 'Jammu and Kashmir Bank' },
    { title: 'Karnataka Bank Ltd' },
    { title: 'Karur Vysya Bank' },
    { title: 'Kotak Bank' },
    { title: 'Laxmi Vilas Bank' },
    { title: 'Oriental Bank of Commerce' },
    { title: 'Others' },
    { title: 'Punjab National Bank' },
    { title: 'Punjab & Sind Bank' },
    { title: 'South Indian Bank' },
    { title: 'State Bank of Bikaner & Jaipur' },
    { title: 'State Bank of Hyderabad' },
    { title: 'State Bank of India' },
    { title: 'State Bank of Mysore' },
    { title: 'State Bank of Patiala' },
    { title: 'State Bank of Travancore' },
    { title: 'Syndicate Bank' },
    { title: 'UCO Bank' },
    { title: 'Union Bank of India' },
    { title: 'United Bank of India' },
    { title: 'Vijaya Bank' },
    { title: 'Yes Bank Ltd' },
    { title: 'Bandhan Bank' },
]

export const BankDetails: React.FC<BankDetailsProps> = (props: BankDetailsProps) =>{

    const{
        handleToUpdatePayment, bankMsg, 
        handleToProceed, previousBankDetails, amount, prevBankType, previouslyAddedBankTransaction, removePreiouslyAddedBanks
    } = props;

    const [name, setName] = useState('')
    const [bankName, setBankName] = useState('')
    const [otherBankName, setOtherBankName] = useState('')
    const [accNo, setAccNo] = useState('')
    const [accNoReEntered, setAccNoReEntered] = useState('')
    const [ifsc, setIfsc] = useState('')
    const [message, setMessage] = useState('')

    const handleChange = (value: any) => {
        if(value && value !== null) {
            setBankName(value)
        }
        else {
            setBankName('')
        }

        if(value !== 'Others') {
            setOtherBankName('')
        }
    }

    const handleToUpdateContent = (name:string, arg:string) => {
        if(name === 'name'){
            setName(arg)
        }
        if(name === 'accNo'){
            setAccNo(arg)
        }
        if(name === 'accNoReEntered'){
            setAccNoReEntered(arg)
        }
        if(name === 'ifsc'){
            setIfsc(arg)
        }
        if(name === 'otherBankName' && bankName === 'Others'){
            setOtherBankName(arg)
        }
    }
    
    const handleToUpdateBankDetails = (arg: string) => { 
        const data = {
            name: name,
            accNo: accNo,
            ifsc: ifsc,
            bankName: bankName,
            otherBankName: otherBankName
        }
        var re = /^([A-Z]{4}[0-9]{7}$|^[A-Za-z]{4}[a-zA-Z0-9]{7})$/;
        // var regexBankName = /^[a-zA-Z][a-zA-Z ]*$/; // allow only letter white space
        var regexBankName = /^[A-Za-z][A-Za-z ]{0,49}$/; // allow only letter white space
        if(accNo !== accNoReEntered){
            setMessage('Account numbers do not match')
        }
        else if(accNo.length < 8 || accNo.length > 19){
            setMessage('Please enter a valid account number')
        }
        else if(name.length < 1){
            setMessage('Please enter your name')
        }
        else if(bankName.length < 1){
            setMessage('Please enter bank name')
        }
        else if(bankName === 'Others' && regexBankName.test(otherBankName) === false){
            setMessage('Please enter valid bank name')
        }
        else if(ifsc.length !== 11 || re.test(ifsc) === false){
            setMessage('Please enter a valid IFSC code')
        }
        else{
         handleToUpdatePayment(data)
        }
    }

    $(document).ready(function() {
        $("#re_enter_account_number").bind({
            copy : function(){
                return false;
            },
            paste : function(){
                return false;
            },
            cut : function(){
                return false;
            }
        });
    }); 
    return (
            <div className='bankDetails'>

                    <div className='buttonAndLabel withoutTopLabel'>
                        <Button className='goBack' onClick={() => {handleToUpdatePayment('GoBack')}} ><ClearIcon /></Button> 
                        <p>Enter Bank Details</p>
                    </div>
                    <div className='buttonAndLabel withToplabel'>
                        <Label content='Account Transfer' />
                        <div className='sideText'>Directly transfer to your bank account</div>   
                    </div> 
                    <div className='account_details'>
                        <br></br>
                        <Label content='Name' />
                        <TextBox className='textBox'
                                label={'Name'} 
                                state={'name'}
                                placeholder={'Enter your name'} 
                                handleToUpdate={handleToUpdateContent} 
                        />
                        <Label content='Bank Name' />
                        <div className="textbox">
                        <Autocomplete
                                id="size-small-filled"
                                size="small"
                                onChange={(event, value) => handleChange(value && value.title)}
                                options={BanksList}
                                getOptionLabel={(option) => option.title}
                                defaultValue={BanksList[50]}
                                renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                    variant="outlined"
                                    label={option.title}
                                    size="small"
                                    {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField {...params} variant="filled" label="Enter bank name" placeholder="Enter bank name" />
                            )}
                        />
                        </div>
                        {bankName === 'Others' ?
                        <TextBox className='textBox'
                                label={'Bank Name'} 
                                state={'otherBankName'}
                                placeholder={'Enter bank name'} 
                                handleToUpdate={handleToUpdateContent} 
                        /> : null}
                        <Label content='Account Number' />
                        <TextBox className='account_number'
                                label={'Account Number'} 
                                state='accNo'
                                placeholder={'Enter Account Number'} 
                                handleToUpdate={handleToUpdateContent} 
                        />
                        <Label content='Re-enter account number' />
                        <TextBox className='re_enter_account_number'
                                label={'Re-enter Account Number'} 
                                state='accNoReEntered'
                                placeholder={'Re-enter Account Number'} 
                                handleToUpdate={handleToUpdateContent} 
                        />
                        <div className='ifsc-wrap'>
                            <Label content='IFSC' />
                            <div className='ifsc-input-wrap'>

                            <TextBox className='ifsc'
                                    label={'IFSC'} 
                                    state='ifsc'
                                    placeholder={'Enter the IFSC'} 
                                    handleToUpdate={handleToUpdateContent} 
                                    />
                            {/* <a href="javascript:void(0);" className='searchForIFSC'>Search for IFSC</a> */}
                                    </div>
                        </div>

                        <div className='message'>{message}</div>
                        <br></br>
                        <div className='message'>{bankMsg}</div>
                        
                        <ButtonComp label= {'IFSC'} 
                                name={'SAVE ACCOUNT DETAILS'} 
                                visible={true}
                                handleToUpdate={handleToUpdateBankDetails} 
                        />
                    </div>
                    {previousBankDetails.length >0 ?
                    <div className='accountHistory'>
                        <div className='buttonAndLabel withToplabel'>
                            <Label content='Account History' />
                            <div className='sideText'>Your already used bank account details</div>   
                        </div>
                        {/* <ul className='bankListWrap'>
                            <li className='bankItem'>
                                <div className='bankLeftDetails'>
                                    <p className='bankName'>HDFC Bank Debit Card</p>
                                    <p className='cardtype'>MASTER ........7399</p>
                                </div>
                                <div className='bankRightDetails'>
                                    <p className='transitionDate'>24 Nov 2020  10.15 AM</p>
                                </div>
                            </li>
                        </ul> */}
                        <PreviousBankDetails 
                            handleToProceed={handleToProceed} previousBankDetails={previousBankDetails} amount={amount} 
                            prevBankType={prevBankType} previouslyAddedBankTransaction={previouslyAddedBankTransaction} 
                            removePreiouslyAddedBanks={removePreiouslyAddedBanks} />
                    </div> : null}
            </div>             
        )
    }


export default BankDetails